
import React from 'react'
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react'
import ImageLinkHandle from './styles/ImageLinkHandle'

export default function ImageLinkComponent(props) {
  return (
    <NodeViewWrapper className={'draggable-item'}>
      <ImageLinkHandle
        data-drag-handle
        draggable={true}
        contentEditable={false}
        editable={props.editor.options.editable}
        thisStyles={props.node.attrs.style}
        onMouseUp={() => {
          const nodePosition = props.getPos();
          return !props.editor.options.editable ? window.open(props.node.attrs.href, '_blank') : props.editor.commands.setNodeSelection(nodePosition);
        }} 
      >
        <a href={props.node.attrs.href} style={{display: 'block', width: 'fit-cotent'}} contentEditable={false} >
        <NodeViewContent contentEditable={false}/>
        </a>
      </ImageLinkHandle>
    </NodeViewWrapper>
  );
}



